import { antdUtils } from '@/utils/antd';
import { App } from 'antd';
import { useEffect } from 'react';

export default function AntdUtils(props) {
  const { notification, message, modal } = App.useApp();

  useEffect(() => {
    antdUtils.setMessageInstance(message);
    antdUtils.setNotificationInstance(notification);
    antdUtils.setModalInstance(modal);
  }, [notification, message, modal]);

  return <>{props.children}</>;
}
